import appManager from '../../app/appManager';
import AppModule from '../../app/lib/AppModule';
import AuthModule from '../AuthModule';
import { AuthUser } from '../AuthModule/lib/types';
import {
  closeWorkspace,
  openWorkspace,
  serviceState,
} from './workspace/workspace';
import ServiceEvents from './workspace/types/ServiceEvents';

// THIS MODULE IS A WORK IN-PROGRESS A WILL BE REFACTORED
// SEE DAVEW BEFORE MAKING MAJOR CHANGES

export class ServiceModule extends AppModule {
  override events = ['user.status.updated', ...ServiceEvents];
  override preload(): void {
    this.app.events.on('auth.signin', (user: AuthUser) => {
      openWorkspace(
        user.id,
        user.accountId,
        user.accountId,
        user.org.tenants.map((t) => t.id),
        this.app.logger,
      );
    });
    appManager.events.on('auth.signout', () => {
      closeWorkspace();
    });
  }

  override load(): void {
    //
  }

  public refetchWorkspace() {
    const user = AuthModule.user;
    if (user) {
      openWorkspace(
        user.id,
        user.accountId,
        user.accountId,
        user.org.tenants.map((t) => t.id),
        this.app.logger,
      );
    }
  }

  public hasSession(conversationSid: string): boolean {
    return !!Object.values(serviceState.sessions).find(
      (s) => conversationSid === s.conversationId,
    );
  }
}

export default new ServiceModule(
  appManager.events,
  appManager.logger('Service'),
);
